<!-- <section> -->
<rappider-spin [spinning]="!projectId">
  <ng-container *ngIf="projectId">

    <section>
      <nz-card class="project-detail-card"
               [nzBordered]="false">
        <div class="project-description">
          <h3>{{activeProject?.name}}</h3>
          <p>
            {{activeProject?.description}}
          </p>
        </div>
        <nz-divider></nz-divider>
        <p>
          You can customize your project by selecting the features you want to include.
        </p>
      </nz-card>
    </section>


    <section class="customization-menu-content">
      <div class="feature-card-container row">
        <div *ngFor="let feature of features; let i = index"
             class="feature-card col-lg-6 col-md-6 col-sm-12 col-xs-12">
          <div class="feature-card-content">
            <i [class]="feature.icon"></i>
            <h5 class="feature-title">
              {{feature.title}}
            </h5>
            <p class="feature-description">
              {{feature.description}}
            </p>
            <div class="feature-links">
              <ng-container *ngFor="let subFeature of feature.subFeatures">
                <a *ngIf="subFeature?.isVisible !== false && subFeature?.title !== 'Invite Users'; else inviteUserTemplate"
                   class="feature-link"
                   [routerLink]="[subFeature.path]"
                   (click)="onFeatureMenuClicked(subFeature)">{{subFeature.title}}</a>
                <ng-template #inviteUserTemplate>
                  <a *ngIf="isAdminOrManagerUser() && subFeature?.isVisible !== false"
                     class="feature-link"
                     [routerLink]="[subFeature.path]"
                     (click)="onFeatureMenuClicked(subFeature)">{{subFeature.title}}</a>
                </ng-template>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </section>
  </ng-container>
</rappider-spin>
<!-- </section> -->
